export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";
export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";

export const USER_ACCOUNT_DETAILS_FAIL = "USER_ACCOUNT_DETAILS_FAIL";
export const USER_ACCOUNT_DETAILS_REQUEST = "USER_ACCOUNT_DETAILS_REQUEST";
export const USER_ACCOUNT_DETAILS_SUCCESS = "USER_ACCOUNT_DETAILS_SUCCESS";

export const USER_WATCHLIST_FAIL = "USER_WATCHLIST_FAIL";
export const USER_WATCHLIST_REQUEST = "USER_WATCHLIST_REQUEST";
export const USER_WATCHLIST_SUCCESS = "USER_WATCHLIST_SUCCESS";

export const USER_SUBSCRIPTION_DETAILS_FAIL = "USER_SUBSCRIPTION_DETAILS_FAIL";
export const USER_SUBSCRIPTION_DETAILS_REQUEST = "USER_SUBSCRIPTION_DETAILS_REQUEST";
export const USER_SUBSCRIPTION_DETAILS_SUCCESS = "USER_SUBSCRIPTION_DETAILS_SUCCESS";

export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";

export const USER_ACTIVATION_REQUEST = "USER_ACTIVATION_REQUEST"
export const USER_ACTIVATION_SUCCESS = "USER_ACTIVATION_SUCCESS";
export const USER_ACTIVATION_FAIL = "USER_ACTIVATION_FAIL";

export const USER_SIGNIN_FAIL = "USER_SIGNIN_FAIL";
export const USER_SIGNIN_REQUEST = "USER_SIGNIN_REQUEST";
export const USER_SIGNIN_SUCCESS = "USER_SIGNIN_SUCCESS";

export const USER_GOOGLE_SIGNIN_FAIL = "USER_GOOGLE_SIGNIN_FAIL";
export const USER_GOOGLE_SIGNIN_REQUEST = "USER_GOOGLE_SIGNIN_REQUEST";
export const USER_GOOGLE_SIGNIN_SUCCESS = "USER_GOOGLE_SIGNIN_SUCCESS";

export const USER_SIGNOUT = "USER_SIGNOUT";

export const USER_UPDATE_PROFILE_FAIL = "USER_UPDATE_PROFILE_FAIL";
export const USER_UPDATE_PROFILE_REQUEST = "USER_UPDATE_PROFILE_REQUEST";
export const USER_UPDATE_PROFILE_SUCCESS = "USER_UPDATE_PROFILE_SUCCESS";

export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";

export const USER_DELETE_REQUEST = "USER_DELETE_REQUEST";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_FAIL = "USER_DELETE_FAIL";

export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";

export const USER_TOPSELLERS_LIST_REQUEST = "USER_TOPSELLERS_LIST_REQUEST";
export const USER_TOPSELLERS_LIST_SUCCESS = "USER_TOPSELLERS_LIST_SUCCESS";
export const USER_TOPSELLERS_LIST_FAIL = "USER_TOPSELLERS_LIST_FAIL";

export const USER_PWD_RESET_MAIL_REQUEST = "USER_PWD_RESET_MAIL_REQUEST";
export const USER_PWD_RESET_MAIL_SUCCESS = "USER_PWD_RESET_MAIL_SUCCESS";
export const USER_PWD_RESET_MAIL_FAIL = "USER_PWD_RESET_MAIL_FAIL";

export const USER_PWD_RESET_CHECK_REQUEST = "USER_PWD_RESET_CHECK_REQUEST";
export const USER_PWD_RESET_CHECK_SUCCESS = "USER_PWD_RESET_CHECK_SUCCESS";
export const USER_PWD_RESET_CHECK_FAIL = "USER_PWD_RESET_CHECK_FAIL";

export const USER_PWD_RESET_REQUEST = "USER_PWD_RESET_REQUEST";
export const USER_PWD_RESET_SUCCESS = "USER_PWD_RESET_SUCCESS";
export const USER_PWD_RESET_FAIL = "USER_PWD_RESET_FAIL";

export const USER_UNSUBSCRIBE_MAIL_REQUEST = "USER_UNSUBSCRIBE_MAIL_REQUEST";
export const USER_UNSUBSCRIBE_MAIL_SUCCESS = "USER_UNSUBSCRIBE_MAIL_SUCCESS";
export const USER_UNSUBSCRIBE_MAIL_FAIL = "USER_UNSUBSCRIBE_MAIL_FAIL";

export const USER_UNSUBSCRIBE_MAIL_SETTINGS_REQUEST = "USER_UNSUBSCRIBE_MAIL_SETTINGS_REQUEST";
export const USER_UNSUBSCRIBE_MAIL_SETTINGS_SUCCESS = "USER_UNSUBSCRIBE_MAIL_SETTINGS_SUCCESS";
export const USER_UNSUBSCRIBE_MAIL_SETTINGS_FAIL = "USER_UNSUBSCRIBE_MAIL_SETTINGS_FAIL";

export const USER_RESUBSCRIBE_MAIL_SETTINGS_REQUEST = "USER_RESUBSCRIBE_MAIL_SETTINGS_REQUEST";
export const USER_RESUBSCRIBE_MAIL_SETTINGS_SUCCESS = "USER_RESUBSCRIBE_MAIL_SETTINGS_SUCCESS";
export const USER_RESUBSCRIBE_MAIL_SETTINGS_FAIL = "USER_RESUBSCRIBE_MAIL_SETTINGS_FAIL";

export const USER_LOGGEDIN_REQUEST = "USER_LOGGEDIN_REQUEST";
export const USER_PREMIUM_REQUEST = "USER_PREMIUM_REQUEST";
export const USER_LOGGEDIN_SUCCESS_PREMIUM_SUCCESS = "USER_LOGGEDIN_SUCCESS_PREMIUM_SUCCESS";
export const USER_LOGGEDIN_SUCCESS_PREMIUM_FAIL = "USER_LOGGEDIN_SUCCESS_PREMIUM_FAIL";
export const USER_LOGGEDIN_FAIL_PREMIUM_FAIL = "USER_LOGGEDIN_FAIL_PREMIUM_FAIL";
export const USER_LOGGEDIN_FAIL = "USER_LOGGEDIN_FAIL";
export const USER_PREMIUM_FAIL = "USER_PREMIUM_FAIL";

export const USER_COUNTRY_REQUEST = "USER_COUNTRY_REQUEST";
export const USER_COUNTRY_SUCCESS = "USER_COUNTRY_SUCCESS";
export const USER_COUNTRY_FAIL = "USER_COUNTRY_FAIL";


export const CHECK_USER = "CHECK_USER";